module.exports = __webpack_public_path__ + "img/Hypoxia-BRCA_10X_Section1.cca004c8.png";